<template>
  <div>
    <video id="my-video" class="video-js" controls preload="auto" width="640" height="264"
           poster="https://inesa-test.oss-cn-shanghai.aliyuncs.com/1.png" data-setup="{}">
      <source src="http://vod.bylonline.cn/1bf284f3f0d046bfaa154043b5edf181/f58f4a89dbf3456c44a5a6e5939a891c-sd.mp4" type='video/mp4'>
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
      </p>
    </video>
  </div>
</template>
<script>

export default {
  components: { },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    this.videoControl()
  },
  methods: {
    videoControl () {
      var options = {};
      var player = videojs('my-video', options, function onPlayerReady () {
        videojs.log('Your player is ready!');
        // In this context, `this` is the player that was created by Video.js.
        this.on('timeupdate', function () {
          videojs.log('playing!');
        });
        // How about an event listener?
        this.on('ended', function () {
          videojs.log('Awww...over so soon?!');
        });
      });
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/test.vue